export default __webpack_public_path__ + "static/media/visa.00400984.svg";